'use client';
import Button from '@/ui/Button';
import { IRepository } from '@/types';
import * as Icon from '@/ui/Icon';
import useOxenSession from '@/hooks/useOxenSession';

const ForkRepositoryButton = ({ repository }: { repository: IRepository }) => {
  const { authorization } = useOxenSession();
  const repoAuth = authorization.forRepository(repository);

  const gatedAccessRequired = repository.visibility === 'gated' && !repoAuth.canFork();
  const tooltipContent = gatedAccessRequired ? 'This repository requires gated access to fork.' : undefined;

  return (
    <Button.Success
      tooltip={tooltipContent}
      href={`/${repository.namespace}/${repository.name}/fork`}
      small
      disabled={!repoAuth.canFork()}
    >
      <Icon.Fork style={{ marginRight: 5 }} /> Fork this repository to run your own evaluations
    </Button.Success>
  );
};

const CreateEvaluationButton: React.FC<{
  repository: IRepository;
  sectionNavigationPath: string;
  hasEvaluations: boolean;
}> = ({ repository, sectionNavigationPath, hasEvaluations }) => {
  const { authorization } = useOxenSession();
  const repoAuth = authorization.forRepository(repository);
  const canCreateEvaluations = repoAuth.canCreateEvaluations();

  if (!repoAuth.canCreateEvaluations()) {
    return <ForkRepositoryButton repository={repository} />;
  }

  return (
    <Button.Black
      small
      href={`/${repository.namespace}/${repository.name}/${sectionNavigationPath}/new`}
      disabled={!canCreateEvaluations}
    >
      Create {!hasEvaluations && 'your first '}Evaluation
    </Button.Black>
  );
};

export default CreateEvaluationButton;
